import 'waypoints/lib/noframework.waypoints.min';

export const initFixedContacts = (contextNode) => {
  const fixedContactsNode = document.getElementById('fixed-contacts');
  const salesCenterNode = document.querySelector('#sales-center [data-contacts-block]');
  const buildingMenu = document.getElementById('building-menu');
  if (!fixedContactsNode || !salesCenterNode) return;

  let isHidden = true;

  const setHidden = (hidden) => {
    if (hidden === isHidden) return;

    isHidden = hidden;
    fixedContactsNode.classList.toggle('-hidden', hidden);
  };

  new window.Waypoint({
    element: salesCenterNode,
    handler: function handler(direction) {
      const isPassed = direction === 'down';
      setHidden(!isPassed);
    },
    offset: function offset() {
      const buildingMenuHeight = buildingMenu?.getBoundingClientRect().height || 0;
      return -1 * (this.element.clientHeight - buildingMenuHeight);
    },
    ...(contextNode && { context: contextNode }),
  });
};

initFixedContacts();
